// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"473":"8a358c67","494":"e10e3130","570":"b4243e17","748":"8a358c67"}[chunkId] + ".chunk.css";
};